import React, { useContext, useEffect, useState } from "react";
import client from "../../../helpers/Client";
import {
  Box,
  Button,
  Card,
  CardBody,
  CardHeader,
  Center,
  Checkbox,
  Container,
  Flex,
  FormControl,
  FormHelperText,
  FormLabel,
  Heading,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  InputLeftElement,
  Select,
  Stack,
  Text,
  VStack,
  Icon,
  Fade,
  useToast,
  Progress,
  Badge,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Divider,
  SimpleGrid,
  Tooltip,
  IconButton,
  useBreakpointValue,
} from "@chakra-ui/react";
import {
  FiUser,
  FiPhone,
  FiMail,
  FiLock,
  FiSettings,
  FiEye,
  FiEyeOff,
  FiCheck,
  FiX,
  FiCopy,
  FiRefreshCw,
  FiArrowLeft
} from "react-icons/fi";
import "../../Public/Support/style.css";
import AuthContext from "../../../contexts/Auth";
import { useNavigate } from "react-router-dom";

export function SuccessBox({ username, password }) {
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const [copied, setCopied] = useState(false);
  const navigate = useNavigate();
  const toast = useToast();

  const handleClick = () => setShow1(!show1);
  const handleClick2 = () => setShow2(!show2);

  const copyToClipboard = (text, label) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopied(true);
        toast({
          title: "Kopyalandı!",
          description: `${label} başarıyla panoya kopyalandı.`,
          status: "success",
          duration: 2000,
          isClosable: true,
        });
        setTimeout(() => setCopied(false), 2000);
      })
      .catch((error) => {
        toast({
          title: "Hata!",
          description: "Kopyalama işlemi başarısız oldu.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      });
  };

  const bgGradient = "linear(to-br, green.50, blue.50, purple.50)";
  const cardBg = "white";
  const textColor = "gray.800";
  const successColor = "green.500";

  return (
    <Box
      minH="100vh"
      bgGradient={bgGradient}
      display="flex"
      alignItems="center"
      justifyContent="center"
      p={4}
    >
      <Card
        bg={cardBg}
        shadow="2xl"
        borderRadius="2xl"
        maxW="lg"
        w="full"
        overflow="hidden"
      >
        <CardBody p={8}>
          {/* Success Icon */}
          <VStack spacing={6}>
            <Box
              bg={successColor}
              borderRadius="full"
              p={4}
              animation="pulse 2s infinite"
            >
              <Icon as={FiCheck} boxSize={12} color="white" />
            </Box>

            <VStack spacing={2} textAlign="center">
              <Heading
                color={successColor}
                fontSize={{ base: "xl", md: "2xl" }}
                fontWeight="bold"
              >
                Personel Başarıyla Oluşturuldu!
              </Heading>
              <Text color={textColor} fontSize="md" opacity={0.8}>
                Yeni personel hesabı aktif ve kullanıma hazır.
              </Text>
            </VStack>

            <Divider />

            {/* Credentials */}
            <VStack spacing={4} w="full">
              <Text fontWeight="semibold" color={textColor}>
                Giriş Bilgileri:
              </Text>

              {/* Username */}
              <FormControl>
                <FormLabel fontSize="sm" color={textColor}>Kullanıcı Adı:</FormLabel>
                <InputGroup>
                  <Input
                    value={username}
                    type={show1 ? "text" : "password"}
                    isReadOnly
                    bg={"gray.50"}
                    borderColor={"gray.200"}
                  />
                  <InputRightElement>
                    <HStack spacing={1}>
                      <IconButton
                        size="sm"
                        variant="ghost"
                        icon={show1 ? <FiEyeOff /> : <FiEye />}
                        onClick={handleClick}
                        aria-label={show1 ? "Gizle" : "Göster"}
                      />
                      <IconButton
                        size="sm"
                        variant="ghost"
                        icon={<FiCopy />}
                        onClick={() => copyToClipboard(username, "Kullanıcı adı")}
                        aria-label="Kopyala"
                        colorScheme={copied ? "green" : "gray"}
                      />
                    </HStack>
                  </InputRightElement>
                </InputGroup>
              </FormControl>

              {/* Password */}
              <FormControl>
                <FormLabel fontSize="sm" color={textColor}>Şifre:</FormLabel>
                <InputGroup>
                  <Input
                    value={password}
                    type={show2 ? "text" : "password"}
                    isReadOnly
                    bg={"gray.50"}
                    borderColor={"gray.200"}
                  />
                  <InputRightElement>
                    <HStack spacing={1}>
                      <IconButton
                        size="sm"
                        variant="ghost"
                        icon={show2 ? <FiEyeOff /> : <FiEye />}
                        onClick={handleClick2}
                        aria-label={show2 ? "Gizle" : "Göster"}
                      />
                      <IconButton
                        size="sm"
                        variant="ghost"
                        icon={<FiCopy />}
                        onClick={() => copyToClipboard(password, "Şifre")}
                        aria-label="Kopyala"
                        colorScheme={copied ? "green" : "gray"}
                      />
                    </HStack>
                  </InputRightElement>
                </InputGroup>
              </FormControl>
            </VStack>

            <Divider />

            {/* Action Buttons */}
            <VStack spacing={3} w="full">
              <Button
                w="full"
                colorScheme="green"
                size="lg"
                onClick={() => copyToClipboard(
                  `Kullanıcı Adı: ${username}\nŞifre: ${password}`,
                  "Tüm bilgiler"
                )}
                leftIcon={<FiCopy />}
              >
                Tüm Bilgileri Kopyala
              </Button>

              <Button
                w="full"
                variant="outline"
                onClick={() => navigate('/personel-listesi/')}
                leftIcon={<FiArrowLeft />}
              >
                Personel Listesine Dön
              </Button>
            </VStack>
          </VStack>
        </CardBody>
      </Card>
    </Box>
  );
}

export function Contact({ isPublic }) {
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [generatedPassword, setGeneratedPassword] = useState("");

  // Form validation states
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  // Password strength
  const [passwordStrength, setPasswordStrength] = useState(0);
  const [passwordSuggestions, setPasswordSuggestions] = useState([]);

  const navigate = useNavigate();
  const [newusername, setNewusername] = useState();
  const [newpassword, setNewpassword] = useState();
  const [email, setEmail] = useState("");
  const [errorData, setErrorData] = useState({});
  const [resellers, setResellers] = useState();
  const [selectedResellerURL, setSelectedResellerURL] = useState();
  const [isChecked, setIsChecked] = useState(false);
  const auth = useContext(AuthContext);
  const isAdmin = auth.data.user.employee.is_manager;
  const toast = useToast();

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  // Modern color mode values
  const bgColor = 'white';
  const borderColor = 'gray.200';
  const inputBg = 'gray.50';
  const inputFocusBg = 'white';
  const textColor = 'gray.800';
  const placeholderColor = 'gray.500';
  const cardColor = "gray.50";
  const checkboxBg = 'blue.50';
  const checkboxBorderColor = 'blue.200';
  const checkboxTextColor = 'gray.600';

  // Form validation functions
  const validateField = (name, value) => {
    const newErrors = { ...errors };

    switch (name) {
      case 'username':
        if (!value.trim()) {
          newErrors.username = 'Kullanıcı adı gereklidir';
        } else if (value.length < 3) {
          newErrors.username = 'Kullanıcı adı en az 3 karakter olmalıdır';
        } else if (!/^[a-zA-Z0-9_]+$/.test(value)) {
          newErrors.username = 'Kullanıcı adı sadece harf, rakam ve alt çizgi içerebilir';
        } else {
          delete newErrors.username;
        }
        break;
      case 'firstName':
        if (!value.trim()) {
          newErrors.firstName = 'Ad gereklidir';
        } else if (value.length < 2) {
          newErrors.firstName = 'Ad en az 2 karakter olmalıdır';
        } else {
          delete newErrors.firstName;
        }
        break;
      case 'lastName':
        if (!value.trim()) {
          newErrors.lastName = 'Soyad gereklidir';
        } else if (value.length < 2) {
          newErrors.lastName = 'Soyad en az 2 karakter olmalıdır';
        } else {
          delete newErrors.lastName;
        }
        break;
      case 'email':
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!value.trim()) {
          newErrors.email = 'E-posta gereklidir';
        } else if (!emailRegex.test(value)) {
          newErrors.email = 'Geçerli bir e-posta adresi giriniz';
        } else {
          delete newErrors.email;
        }
        break;
      case 'phoneNumber':
        if (!value || !value.trim()) {
          newErrors.phoneNumber = 'Telefon numarası gereklidir';
        } else {
          const cleanedPhone = value.replace(/\s/g, '');
          if (!/^[0-9]{10}$/.test(cleanedPhone)) {
            newErrors.phoneNumber = 'Geçerli bir telefon numarası giriniz (10 haneli)';
          } else if (!cleanedPhone.startsWith('5')) {
            newErrors.phoneNumber = 'Telefon numarası 5 ile başlamalıdır';
          } else {
            delete newErrors.phoneNumber;
          }
        }
        break;
      case 'password':
        if (!value) {
          newErrors.password = 'Şifre gereklidir';
        } else {
          delete newErrors.password;
        }
        break;
    }

    setErrors(newErrors);
  };

  // Password strength calculation
  const calculatePasswordStrength = (password) => {
    let strength = 0;
    const suggestions = [];

    if (password.length >= 8) strength += 20;
    else suggestions.push('En az 8 karakter kullanın');

    if (/[a-z]/.test(password)) strength += 20;
    else suggestions.push('Küçük harf ekleyin');

    if (/[A-Z]/.test(password)) strength += 20;
    else suggestions.push('Büyük harf ekleyin');

    if (/[0-9]/.test(password)) strength += 20;
    else suggestions.push('Rakam ekleyin');

    if (/[^a-zA-Z0-9]/.test(password)) strength += 20;
    else suggestions.push('Özel karakter ekleyin (!@#$%^&*)');

    setPasswordStrength(strength);
    setPasswordSuggestions(suggestions);
  };

  // Generate secure password
  const generateSecurePassword = () => {
    const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*';
    let result = '';

    // Ensure at least one of each type
    result += 'abcdefghijklmnopqrstuvwxyz'[Math.floor(Math.random() * 26)];
    result += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[Math.floor(Math.random() * 26)];
    result += '0123456789'[Math.floor(Math.random() * 10)];
    result += '!@#$%^&*'[Math.floor(Math.random() * 8)];

    // Fill the rest randomly
    for (let i = 4; i < 12; i++) {
      result += chars[Math.floor(Math.random() * chars.length)];
    }

    // Shuffle the result
    const shuffled = result.split('').sort(() => Math.random() - 0.5).join('');
    setGeneratedPassword(shuffled);
    setPassword(shuffled);
    calculatePasswordStrength(shuffled);

    toast({
      title: "Güvenli şifre oluşturuldu!",
      description: "Şifre otomatik olarak dolduruldu.",
      status: "success",
      duration: 2000,
      isClosable: true,
    });
  };

  // Phone number formatting function
  const formatPhoneNumber = (value) => {
    // Remove all non-digits
    const cleaned = value.replace(/\D/g, '');

    // Limit to 10 digits
    const limited = cleaned.slice(0, 10);

    // Format as XXX XXX XX XX
    if (limited.length >= 7) {
      return `${limited.slice(0, 3)} ${limited.slice(3, 6)} ${limited.slice(6, 8)} ${limited.slice(8, 10)}`;
    } else if (limited.length >= 4) {
      return `${limited.slice(0, 3)} ${limited.slice(3, 6)} ${limited.slice(6)}`;
    } else if (limited.length >= 1) {
      return `${limited.slice(0, 3)} ${limited.slice(3)}`;
    }
    return limited;
  };

  // Handle field changes with validation
  const handleFieldChange = (name, value) => {
    switch (name) {
      case 'username':
        setUsername(value);
        break;
      case 'firstName':
        setFirstName(value);
        break;
      case 'lastName':
        setLastName(value);
        break;
      case 'email':
        setEmail(value);
        break;
      case 'phoneNumber':
        const formattedPhone = formatPhoneNumber(value);
        setPhoneNumber(formattedPhone);
        break;
      case 'password':
        setPassword(value);
        calculatePasswordStrength(value);
        break;
    }

    if (touched[name]) {
      validateField(name, value);
    }
  };

  // Handle field blur (robust against undefined values)
  const handleFieldBlur = (name, value) => {
    setTouched((prev) => ({ ...prev, [name]: true }));
    const currentValues = {
      username,
      firstName,
      lastName,
      email,
      phoneNumber,
      password,
      selectedResellerURL,
    };
    const resolvedValue = value !== undefined ? value : (currentValues[name] ?? "");
    validateField(name, resolvedValue);
  };

  useEffect(() => {
    if (!isPublic) {
      client.get("/resellers/").then((response) => setResellers(response.data));
    }
  }, [isPublic]);

  const handleDashboardForm = () => {
    // Validate all fields before submission
    const fieldsToValidate = {
      username,
      firstName,
      lastName,
      email,
      phoneNumber,
      password
    };

    // Mark all fields as touched
    const allTouched = {};
    Object.keys(fieldsToValidate).forEach(key => {
      allTouched[key] = true;
      validateField(key, fieldsToValidate[key]);
    });
    setTouched(allTouched);

    // Check if there are any validation errors
    const hasErrors = Object.keys(errors).length > 0 ||
      !username.trim() || !firstName.trim() || !lastName.trim() ||
      !email.trim() || !phoneNumber.trim() || !password.trim();

    if (hasErrors) {
      toast({
        title: "Form Hatası!",
        description: "Lütfen tüm alanları doğru şekilde doldurunuz.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    // Check password strength
    if (passwordStrength < 60) {
      toast({
        title: "Zayıf Şifre!",
        description: "Lütfen daha güvenli bir şifre seçiniz.",
        status: "warning",
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    setErrorData({});
    setLoading(true);

    const requestBody = {
      username: username.trim(),
      first_name: firstName.trim(),
      last_name: lastName.trim(),
      email: email.trim(),
      password: password,
      is_manager: isChecked,
      avatar: null,
      phone_number: "+90" + phoneNumber.replace(/\s/g, ''),
      reseller: isAdmin
        ? selectedResellerURL
        : auth.data.user.employee.reseller.url,
    };

    client
      .post(`/employees/`, requestBody)
      .then(() => {
        toast({
          title: "Başarılı!",
          description: "Yeni personel kaydı başarıyla oluşturuldu.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        setNewusername(username);
        setNewpassword(password);
      })
      .catch((error) => {
        setErrorData(error?.response?.data || {});
        toast({
          title: "Hata!",
          description:
            error?.response?.data?.detail ||
            error?.message ||
            "Personel kaydı oluşturulurken bir hata oluştu.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (newusername) {
    return <SuccessBox username={newusername} password={newpassword} />;
  }

  return (
    <Box position={"relative"}>
      <Stack
        bg={cardColor}
        rounded={"xl"}
        minW={{ base: "340px", sm: "440px", md: "540px" }}
        p={{ base: 3, sm: 6, md: 8 }}
        spacing={{ base: 2 }}
        maxW={{ lg: "lg" }}
      >
        <Stack spacing={4}>
          <Heading
            textAlign={"center"}
            color={"gray.800"}
            lineHeight={1.1}
            fontSize={{ base: "2xl", sm: "3xl", md: "4xl" }}
          >
            Yeni Personel Ekle
          </Heading>
          <Box as={"form"} mt={10}>
            <Stack spacing={4}>
              <FormControl isInvalid={errors.username && touched.username}>
                <FormLabel color={textColor} fontWeight="semibold">
                  Kullanıcı Adı:
                  <Text as="span" color="red.500" ml={1}>*</Text>
                </FormLabel>
                <InputGroup>
                  <InputLeftElement pointerEvents="none">
                    <Icon as={FiUser} color={placeholderColor} />
                  </InputLeftElement>
                  <Input
                    type="text"
                    value={username}
                    onChange={(e) => handleFieldChange('username', e.target.value)}
                    onBlur={(e) => handleFieldBlur('username', e.target.value)}
                    bg={inputBg}
                    border="1px solid"
                    borderColor={errors.username && touched.username ? 'red.300' : borderColor}
                    color={textColor}
                    _placeholder={{ color: placeholderColor }}
                    _hover={{ borderColor: errors.username && touched.username ? 'red.400' : 'blue.300' }}
                    _focus={{
                      borderColor: errors.username && touched.username ? 'red.500' : 'blue.500',
                      bg: inputFocusBg,
                      boxShadow: errors.username && touched.username ?
                        '0 0 0 1px var(--chakra-colors-red-500)' :
                        '0 0 0 1px var(--chakra-colors-blue-500)'
                    }}
                    borderRadius="12px"
                    h="48px"
                    pl="40px"
                    placeholder="Kullanıcı adı giriniz"
                  />
                  {username && !errors.username && touched.username && (
                    <InputRightElement>
                      <Icon as={FiCheck} color="green.500" />
                    </InputRightElement>
                  )}
                </InputGroup>
                {errors.username && touched.username && (
                  <FormHelperText color="red.500" fontSize="sm">
                    <Icon as={FiX} mr={1} />
                    {errors.username}
                  </FormHelperText>
                )}
                {errorData.username &&
                  errorData.username.map((e) => (
                    <FormHelperText key={e} color="red.500">
                      {e}
                    </FormHelperText>
                  ))}
              </FormControl>
              <FormControl isInvalid={errors.firstName && touched.firstName}>
                <FormLabel color={textColor} fontWeight="semibold">
                  Ad:
                  <Text as="span" color="red.500" ml={1}>*</Text>
                </FormLabel>
                <InputGroup>
                  <InputLeftElement pointerEvents="none">
                    <Icon as={FiUser} color={placeholderColor} />
                  </InputLeftElement>
                  <Input
                    type="text"
                    value={firstName}
                    onChange={(e) => handleFieldChange('firstName', e.target.value)}
                    onBlur={(e) => handleFieldBlur('firstName', e.target.value)}
                    bg={inputBg}
                    border="1px solid"
                    borderColor={errors.firstName && touched.firstName ? 'red.300' : borderColor}
                    color={textColor}
                    _placeholder={{ color: placeholderColor }}
                    _hover={{ borderColor: errors.firstName && touched.firstName ? 'red.400' : 'blue.300' }}
                    _focus={{
                      borderColor: errors.firstName && touched.firstName ? 'red.500' : 'blue.500',
                      bg: inputFocusBg,
                      boxShadow: errors.firstName && touched.firstName ?
                        '0 0 0 1px var(--chakra-colors-red-500)' :
                        '0 0 0 1px var(--chakra-colors-blue-500)'
                    }}
                    borderRadius="12px"
                    h="48px"
                    pl="40px"
                    placeholder="Adınızı giriniz"
                  />
                  {firstName && !errors.firstName && touched.firstName && (
                    <InputRightElement>
                      <Icon as={FiCheck} color="green.500" />
                    </InputRightElement>
                  )}
                </InputGroup>
                {errors.firstName && touched.firstName && (
                  <FormHelperText color="red.500" fontSize="sm">
                    <Icon as={FiX} mr={1} />
                    {errors.firstName}
                  </FormHelperText>
                )}
                {errorData.first_name &&
                  errorData.first_name.map((e) => (
                    <FormHelperText key={e} color="red.500">
                      {e}
                    </FormHelperText>
                  ))}
              </FormControl>
              <FormControl isInvalid={errors.lastName && touched.lastName}>
                <FormLabel color={textColor} fontWeight="semibold">
                  Soyad:
                  <Text as="span" color="red.500" ml={1}>*</Text>
                </FormLabel>
                <InputGroup>
                  <InputLeftElement pointerEvents="none">
                    <Icon as={FiUser} color={placeholderColor} />
                  </InputLeftElement>
                  <Input
                    type="text"
                    value={lastName}
                    onChange={(e) => handleFieldChange('lastName', e.target.value)}
                    onBlur={(e) => handleFieldBlur('lastName', e.target.value)}
                    bg={inputBg}
                    border="1px solid"
                    borderColor={errors.lastName && touched.lastName ? 'red.300' : borderColor}
                    color={textColor}
                    _placeholder={{ color: placeholderColor }}
                    _hover={{ borderColor: errors.lastName && touched.lastName ? 'red.400' : 'blue.300' }}
                    _focus={{
                      borderColor: errors.lastName && touched.lastName ? 'red.500' : 'blue.500',
                      bg: inputFocusBg,
                      boxShadow: errors.lastName && touched.lastName ?
                        '0 0 0 1px var(--chakra-colors-red-500)' :
                        '0 0 0 1px var(--chakra-colors-blue-500)'
                    }}
                    borderRadius="12px"
                    h="48px"
                    pl="40px"
                    placeholder="Soyadınızı giriniz"
                  />
                  {lastName && !errors.lastName && touched.lastName && (
                    <InputRightElement>
                      <Icon as={FiCheck} color="green.500" />
                    </InputRightElement>
                  )}
                </InputGroup>
                {errors.lastName && touched.lastName && (
                  <FormHelperText color="red.500" fontSize="sm">
                    <Icon as={FiX} mr={1} />
                    {errors.lastName}
                  </FormHelperText>
                )}
                {errorData.last_name &&
                  errorData.last_name.map((e) => (
                    <FormHelperText key={e} color="red.500">
                      {e}
                    </FormHelperText>
                  ))}
              </FormControl>

              {/* Password Field with Strength Indicator */}
              <FormControl isInvalid={errors.password && touched.password}>
                <HStack justify="space-between" align="center">
                  <FormLabel color={textColor} fontWeight="semibold" mb={0}>
                    Şifre:
                    <Text as="span" color="red.500" ml={1}>*</Text>
                  </FormLabel>
                  <Tooltip label="Güvenli şifre oluştur" placement="top">
                    <IconButton
                      size="sm"
                      variant="ghost"
                      colorScheme="blue"
                      icon={<FiRefreshCw />}
                      onClick={generateSecurePassword}
                      aria-label="Güvenli şifre oluştur"
                    />
                  </Tooltip>
                </HStack>
                <InputGroup>
                  <InputLeftElement pointerEvents="none">
                    <Icon as={FiLock} color={placeholderColor} />
                  </InputLeftElement>
                  <Input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => handleFieldChange('password', e.target.value)}
                    onBlur={(e) => handleFieldBlur('password', e.target.value)}
                    bg={inputBg}
                    border="1px solid"
                    borderColor={errors.password && touched.password ? 'red.300' : borderColor}
                    color={textColor}
                    _placeholder={{ color: placeholderColor }}
                    _hover={{ borderColor: errors.password && touched.password ? 'red.400' : 'blue.300' }}
                    _focus={{
                      borderColor: errors.password && touched.password ? 'red.500' : 'blue.500',
                      bg: inputFocusBg,
                      boxShadow: errors.password && touched.password ?
                        '0 0 0 1px var(--chakra-colors-red-500)' :
                        '0 0 0 1px var(--chakra-colors-blue-500)'
                    }}
                    borderRadius="12px"
                    h="48px"
                    pl="40px"
                    pr="80px"
                    placeholder="Güvenli bir şifre giriniz"
                  />
                  <InputRightElement width="70px">
                    <HStack spacing={1}>
                      <IconButton
                        size="sm"
                        variant="ghost"
                        icon={showPassword ? <FiEyeOff /> : <FiEye />}
                        onClick={() => setShowPassword(!showPassword)}
                        aria-label={showPassword ? "Şifreyi gizle" : "Şifreyi göster"}
                      />
                    </HStack>
                  </InputRightElement>
                </InputGroup>

                {/* Password Strength Indicator */}
                {password && (
                  <VStack spacing={2} mt={2} align="stretch">
                    <HStack justify="space-between">
                      <Text fontSize="sm" color={textColor}>Şifre Gücü:</Text>
                      <Badge
                        colorScheme={
                          passwordStrength >= 80 ? 'green' :
                            passwordStrength >= 60 ? 'yellow' :
                              passwordStrength >= 40 ? 'orange' : 'red'
                        }
                        variant="subtle"
                      >
                        {passwordStrength >= 80 ? 'Çok Güçlü' :
                          passwordStrength >= 60 ? 'Güçlü' :
                            passwordStrength >= 40 ? 'Orta' : 'Zayıf'}
                      </Badge>
                    </HStack>
                    <Progress
                      value={passwordStrength}
                      size="sm"
                      borderRadius="full"
                      colorScheme={
                        passwordStrength >= 80 ? 'green' :
                          passwordStrength >= 60 ? 'yellow' :
                            passwordStrength >= 40 ? 'orange' : 'red'
                      }
                    />
                    {passwordSuggestions.length > 0 && (
                      <VStack spacing={1} align="stretch">
                        <Text fontSize="xs" color={textColor} fontWeight="medium">
                          Şifrenizi güçlendirmek için:
                        </Text>
                        {passwordSuggestions.map((suggestion, index) => (
                          <Text key={index} fontSize="xs" color="gray.500" pl={2}>
                            • {suggestion}
                          </Text>
                        ))}
                      </VStack>
                    )}
                  </VStack>
                )}

                {errors.password && touched.password && (
                  <FormHelperText color="red.500" fontSize="sm">
                    <Icon as={FiX} mr={1} />
                    {errors.password}
                  </FormHelperText>
                )}
                {errorData.password &&
                  errorData.password.map((e) => (
                    <FormHelperText key={e} color="red.500">
                      {e}
                    </FormHelperText>
                  ))}
              </FormControl>
              <FormControl isInvalid={errors.email && touched.email}>
                <FormLabel color={textColor} fontWeight="semibold">
                  E-posta <Text as="span" color="red.500">*</Text>
                </FormLabel>
                <InputGroup>
                  <InputLeftElement pointerEvents="none">
                    <Icon as={FiMail} color={placeholderColor} />
                  </InputLeftElement>
                  <Input
                    type="email"
                    value={email}
                    onChange={(e) => handleFieldChange('email', e.target.value)}
                    onBlur={() => handleFieldBlur('email')}
                    bg={inputBg}
                    border="1px solid"
                    borderColor={errors.email && touched.email ? 'red.500' : borderColor}
                    color={textColor}
                    _placeholder={{ color: placeholderColor }}
                    _hover={{ borderColor: errors.email && touched.email ? 'red.400' : 'blue.300' }}
                    _focus={{
                      borderColor: errors.email && touched.email ? 'red.500' : 'blue.500',
                      bg: inputFocusBg,
                      boxShadow: `0 0 0 1px var(--chakra-colors-${errors.email && touched.email ? 'red' : 'blue'}-500)`
                    }}
                    borderRadius="12px"
                    h="48px"
                    pl="40px"
                    pr="40px"
                    placeholder="E-posta adresinizi girin"
                  />
                  <InputRightElement h="48px">
                    {touched.email && (
                      <Icon
                        as={errors.email ? FiX : FiCheck}
                        color={errors.email ? 'red.500' : 'green.500'}
                        boxSize={5}
                      />
                    )}
                  </InputRightElement>
                </InputGroup>
                {errors.email && touched.email && (
                  <FormHelperText color="red.500" fontSize="sm">
                    {errors.email}
                  </FormHelperText>
                )}
                {errorData.email &&
                  errorData.email.map((e) => (
                    <FormHelperText key={e} color="red.500">
                      {e}
                    </FormHelperText>
                  ))}
              </FormControl>
              <FormControl isInvalid={errors.phoneNumber && touched.phoneNumber}>
                <FormLabel color={textColor} fontWeight="semibold">
                  Telefon <Text as="span" color="red.500">*</Text>
                </FormLabel>
                <InputGroup>
                  <InputLeftElement pointerEvents="none">
                    <Icon as={FiPhone} color={placeholderColor} />
                  </InputLeftElement>
                  <Input
                    type="tel"
                    value={phoneNumber}
                    onChange={(e) => handleFieldChange('phoneNumber', e.target.value)}
                    onBlur={(e) => handleFieldBlur('phoneNumber', e.target.value)}
                    bg={inputBg}
                    border="1px solid"
                    borderColor={errors.phoneNumber && touched.phoneNumber ? 'red.500' : borderColor}
                    color={textColor}
                    _placeholder={{ color: placeholderColor }}
                    _hover={{ borderColor: errors.phoneNumber && touched.phoneNumber ? 'red.400' : 'blue.300' }}
                    _focus={{
                      borderColor: errors.phoneNumber && touched.phoneNumber ? 'red.500' : 'blue.500',
                      bg: inputFocusBg,
                      boxShadow: `0 0 0 1px var(--chakra-colors-${errors.phoneNumber && touched.phoneNumber ? 'red' : 'blue'}-500)`
                    }}
                    borderRadius="12px"
                    h="48px"
                    pl="40px"
                    pr="40px"
                    placeholder="5XX XXX XX XX"
                  />
                  <InputRightElement h="48px">
                    {touched.phoneNumber && (
                      <Icon
                        as={errors.phoneNumber ? FiX : FiCheck}
                        color={errors.phoneNumber ? 'red.500' : 'green.500'}
                        boxSize={5}
                      />
                    )}
                  </InputRightElement>
                </InputGroup>
                {errors.phoneNumber && touched.phoneNumber && (
                  <FormHelperText color="red.500" fontSize="sm">
                    {errors.phoneNumber}
                  </FormHelperText>
                )}
                {errorData.phone_number &&
                  errorData.phone_number.map((e) => (
                    <FormHelperText key={e} color="red.500">
                      {e}
                    </FormHelperText>
                  ))}
              </FormControl>
              {isAdmin && (
                <FormControl isInvalid={errors.selectedResellerURL && touched.selectedResellerURL}>
                  <FormLabel color={textColor} fontWeight="semibold">
                    Bayi <Text as="span" color="red.500">*</Text>
                  </FormLabel>
                  <Select
                    bg={inputBg}
                    border="1px solid"
                    borderColor={errors.selectedResellerURL && touched.selectedResellerURL ? 'red.500' : borderColor}
                    color={textColor}
                    _hover={{ borderColor: errors.selectedResellerURL && touched.selectedResellerURL ? 'red.400' : 'blue.300' }}
                    _focus={{
                      borderColor: errors.selectedResellerURL && touched.selectedResellerURL ? 'red.500' : 'blue.500',
                      bg: inputFocusBg,
                      boxShadow: `0 0 0 1px var(--chakra-colors-${errors.selectedResellerURL && touched.selectedResellerURL ? 'red' : 'blue'}-500)`
                    }}
                    borderRadius="12px"
                    h="48px"
                    value={selectedResellerURL}
                    onChange={(e) => {
                      setSelectedResellerURL(e.target.value);
                      handleFieldChange('selectedResellerURL', e.target.value);
                    }}
                    onBlur={() => handleFieldBlur('selectedResellerURL')}
                    placeholder="Bayi seçiniz"
                  >
                    <option value="">
                      Bayi seçiniz
                    </option>
                    {resellers &&
                      resellers.map((reseller) => (
                        <option key={reseller.url} value={reseller.url}>
                          {reseller.name}
                        </option>
                      ))}
                  </Select>
                  {errors.selectedResellerURL && touched.selectedResellerURL && (
                    <FormHelperText color="red.500" fontSize="sm">
                      {errors.selectedResellerURL}
                    </FormHelperText>
                  )}
                  {errorData.reseller &&
                    errorData.reseller.map((e) => (
                      <FormHelperText key={e} color="red.500">
                        {e}
                      </FormHelperText>
                    ))}
                </FormControl>
              )}

              <Box
                p={4}
                bg={checkboxBg}
                borderRadius="12px"
                border="1px solid"
                borderColor={checkboxBorderColor}
              >
                <Checkbox
                  onChange={handleCheckboxChange}
                  isChecked={isChecked}
                  colorScheme="blue"
                  size="lg"
                >
                  <Text color={textColor} fontWeight="medium">
                    Bayi yöneticisi olarak ata
                  </Text>
                </Checkbox>
                <Text fontSize="sm" color={checkboxTextColor} mt={1}>
                  Bu kullanıcı bayi yönetim yetkilerine sahip olacaktır
                </Text>
              </Box>

              <Button
                size="lg"
                mt={8}
                w="full"
                h="56px"
                bgGradient="linear(to-r, blue.500, blue.600)"
                color="white"
                fontWeight="bold"
                fontSize="lg"
                _hover={{
                  bgGradient: "linear(to-r, blue.600, blue.700)",
                  transform: "translateY(-2px)",
                  boxShadow: "xl",
                }}
                _active={{
                  transform: "translateY(0)",
                }}
                isLoading={loading}
                loadingText="Personel oluşturuluyor..."
                onClick={handleDashboardForm}
                borderRadius="12px"
                transition="all 0.2s"
              >
                <Icon as={FiCheck} mr={2} />
                Personel Oluştur
              </Button>
            </Stack>
          </Box>
        </Stack>
      </Stack>
    </Box>
  );
}
export function EmployeeCreate() {
  return (
    <Box height={"100vh"} position={"relative"}>
      <Container
        display={"flex"}
        alignContent={"space-around"}
        flexDirection={"column"}
        flexWrap={"wrap"}
        maxW={"7xl"}
        columns={{ base: 1, md: 1 }}
      >
        <Stack spacing={4}>
          <Contact />
        </Stack>
      </Container>
    </Box>
  );
}
